export default __webpack_public_path__ + "static/media/bezier-curve-sketch.30e6a563.webm";